module.exports = __webpack_public_path__ + "static/img/finger_QRCode.49e5b852.png";